import Vue from "vue";
import VueAxios from "vue-axios";
import axios from "axios";
import { getCookie, UserCookie } from "../packages/bimAir/src/utils/cookie";
import router from "@/router";
import store from "./store";

Vue.use(VueAxios, axios);

const service = axios.create();
// axios.defaults.baseURL = "https://8.134.85.254:9031/api/model-service"
// 这里的config包含每次请求的内容
service.interceptors.request.use(
  (config) => {
    // 添加配置参考文章https://developer.chrome.com/blog/enabling-shared-array-buffer/
    config.headers["Cross-Origin-Embedder-Policy"] = "require-corp";
    config.headers["Cross-Origin-Opener-Policy"] = "same-origin";
    config.headers["Access-Control-Allow-Origin"] = "*";
    config.headers["Access-Control-Allow-Methods"] = "*";
    config.headers["Access-Control-Allow-Headers"] = "*";

    let userId = UserCookie.getInstance().id;
    let token = UserCookie.getInstance().token;
    console.log("config.url----",config.url)
    if (
      config.url.indexOf("web") !== -1 ||
      config.url.indexOf("demo") !== -1 ||
      config.url.indexOf("uniqueness-check") !== -1 ||
      config.url.indexOf("sendSms") !== -1 ||
      config.url.indexOf("register") !== -1 
    ) {
      return config;
    } else if (userId || token) {
      config.headers.UserId = userId;
      config.headers.Authorization = token;
      return config;
    } else {
      router.push("/login");
    }
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);
service.interceptors.response.use(
  (response) => {
    console.log(
      "参数：",
      response.config.data,
      "\n调用：",
      response.config.method,
      response.config.url,
      "\n返回：",
      response.data
    );
    let responseData: {
      code: number;
      msg: string;
      status: boolean;
      data: any;
    } = response.data;
    console.log(response);
    if (responseData.code === 200 && responseData.status === true) {
      return responseData.data === null ? true : responseData.data;
    } else if (responseData.code === undefined) {
      return responseData;
    } else {
      Vue.prototype.$message.error(`${responseData.msg}`);
      return false;
    }
  },
  (error) => {
    if (error.response.data.code === 401) {
      router.push("/login");
    }
    console.error(
      "参数：",
      error.config.data,
      "\n调用：",
      error.config.method,
      error.config.url,
      "\n返回：",
      error.response
    );
    return false;
  }
);

export default service;
